// extracted by mini-css-extract-plugin
module.exports = {"modelViewWrapper":"model-view_modelViewWrapper__2eBEA","modelIFrame":"model-view_modelIFrame__2HZFe"};